import { ResumenGetModelo111ResumenImpuestoDtoProps } from "api/DTOs/ResumenGetModelo111ResumenImpuestoDto"
import { ResumenGetModelo115ResumenImpuestoDtoProps } from "api/DTOs/ResumenGetModelo115ResumenImpuestosDto"
import { ResumenGetModelo303ResumenImpuestoDtoProps } from "api/DTOs/ResumenGetModelo303ResumenImpuestosDto"
import { ResumenGetModelo390ResumenImpuestoDtoProps } from "api/DTOs/ResumenGetModelo390ResumenImpuestoDto"
import { TrimestreEnumType } from "api/Types/TrimestreEnum"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import { periodOfDays } from "./Modelo303/periodOfDaysTrimester"

export interface RedirectParams {
  route: string
  periodo?: TrimestreEnumType
  tipo?: string | number
  modelo?: number
  year: string | number
}

export const RESUMEN_IMPUESTOS_COMPRAS_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      header: `${t("taxSummary.tables.purchases")}`,
      key: "porcentajeImpuesto",
      field: "porcentajeImpuesto",
      body: (
        rowData:
          | ResumenGetModelo111ResumenImpuestoDtoProps
          | ResumenGetModelo115ResumenImpuestoDtoProps
          | ResumenGetModelo303ResumenImpuestoDtoProps
          | ResumenGetModelo115ResumenImpuestoDtoProps
          | ResumenGetModelo390ResumenImpuestoDtoProps
      ) =>
        "nombre" in rowData && rowData.nombre
          ? rowData.nombre
          : rowData?.porcentajeImpuesto
          ? `${rowData?.porcentajeImpuesto}%`
          : "-",
    },
    {
      header: `${t("taxSummary.tables.subtotal")}`,
      key: "subtotal",
      field: "subtotal",
      style: { width: "30%" },
      alignCol: "right",
      bodyClassName: "!tw-text-end",
      body: (
        rowData:
          | ResumenGetModelo303ResumenImpuestoDtoProps
          | ResumenGetModelo390ResumenImpuestoDtoProps
      ) => formatCurrency(rowData?.subtotal ?? 0),
    },
    {
      header: `${t("taxSummary.tables.amount")}`,
      key: "importe",
      field: "importe",
      style: { width: "30%" },
      alignCol: "right",
      bodyClassName: "!tw-text-end",
      body: (
        rowData:
          | ResumenGetModelo303ResumenImpuestoDtoProps
          | ResumenGetModelo390ResumenImpuestoDtoProps
      ) => formatCurrency(rowData?.importe ?? 0),
    },
  ]
  return columns
}

export const RESUMEN_IMPUESTOS_VENTAS_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      header: `${t("taxSummary.tables.sells")}`,
      key: "porcentajeImpuesto",
      field: "porcentajeImpuesto",
      body: (
        rowData:
          | ResumenGetModelo303ResumenImpuestoDtoProps
          | ResumenGetModelo390ResumenImpuestoDtoProps
      ) =>
        rowData?.nombre
          ? rowData?.nombre
          : rowData?.porcentajeImpuesto
          ? `${rowData?.porcentajeImpuesto}%`
          : "-",
    },
    {
      header: `${t("taxSummary.tables.subtotal")}`,
      key: "subtotal",
      field: "subtotal",
      style: { width: "30%" },
      alignCol: "right",
      bodyClassName: "!tw-text-end",
      body: (
        rowData:
          | ResumenGetModelo303ResumenImpuestoDtoProps
          | ResumenGetModelo390ResumenImpuestoDtoProps
      ) => formatCurrency(rowData?.subtotal ?? 0),
    },
    {
      header: `${t("taxSummary.tables.amount")}`,
      key: "importe",
      field: "importe",
      style: { width: "30%" },
      alignCol: "right",
      bodyClassName: "!tw-text-end",
      body: (
        rowData:
          | ResumenGetModelo303ResumenImpuestoDtoProps
          | ResumenGetModelo390ResumenImpuestoDtoProps
      ) => formatCurrency(rowData?.importe ?? 0),
    },
  ]
  return columns
}

export const dateRangesList = (t: TFunction, selectedYear: string) => ({
  YEAR: {
    label: selectedYear,
    value: periodOfDays("YEAR", selectedYear),
  },
  FIRST_TRIMESTER: {
    label: t("dropdownDatesRanges.first"),
    value: periodOfDays("FIRST_TRIMESTER", selectedYear),
  },
  SECOND_TRIMESTER: {
    label: t("dropdownDatesRanges.second"),
    value: periodOfDays("SECOND_TRIMESTER", selectedYear),
  },
  THIRD_TRIMESTER: {
    label: t("dropdownDatesRanges.third"),
    value: periodOfDays("THIRD_TRIMESTER", selectedYear),
  },
  FOURTH_TRIMESTER: {
    label: t("dropdownDatesRanges.fourth"),
    value: periodOfDays("FOURTH_TRIMESTER", selectedYear),
  },
  JANUARY: {
    label: t("dropdownDatesRanges.january"),
    value: periodOfDays("JANUARY", selectedYear),
  },
  FEBRUARY: {
    label: t("dropdownDatesRanges.february"),
    value: periodOfDays("FEBRUARY", selectedYear),
  },
  MARCH: {
    label: t("dropdownDatesRanges.march"),
    value: periodOfDays("MARCH", selectedYear),
  },
  APRIL: {
    label: t("dropdownDatesRanges.april"),
    value: periodOfDays("APRIL", selectedYear),
  },
  MAY: {
    label: t("dropdownDatesRanges.may"),
    value: periodOfDays("MAY", selectedYear),
  },
  JUNE: {
    label: t("dropdownDatesRanges.june"),
    value: periodOfDays("JUNE", selectedYear),
  },
  JULY: {
    label: t("dropdownDatesRanges.july"),
    value: periodOfDays("JULY", selectedYear),
  },
  AUGUST: {
    label: t("dropdownDatesRanges.august"),
    value: periodOfDays("AUGUST", selectedYear),
  },
  SEPTEMBER: {
    label: t("dropdownDatesRanges.september"),
    value: periodOfDays("SEPTEMBER", selectedYear),
  },
  OCTOBER: {
    label: t("dropdownDatesRanges.october"),
    value: periodOfDays("OCTOBER", selectedYear),
  },
  NOVEMBER: {
    label: t("dropdownDatesRanges.november"),
    value: periodOfDays("NOVEMBER", selectedYear),
  },
  DECEMBER: {
    label: t("dropdownDatesRanges.december"),
    value: periodOfDays("DECEMBER", selectedYear),
  },
})
